export class GuestPayment {
    bookingId: string;
    bookingIdNotSet: string;
    checkIn: Date;
    checkInNotSet: string;
    checkOut: Date;
    checkOutNotSet: string;
    listingDescription: string;
    hostName: string;
    paymentDueDate: Date;
    paymentStatus: string;
    amount: number;
    refundDueDate: Date;
    blockRefundEnabled: boolean;
    refundEnabled: boolean;
    verificationPaymentType: string;
    verificationToPaymentId: number;
    currencyIso: string
}

export class GuestPaymentRefund {
    verificationToPaymentId: number;
    refundDueDate: Date;
}